<ng-container *ngIf="checkComponentFast()">
    <button mat-mini-fab color="primary" class="positionAbsoliteRight0" aria-label="edit RC" (click)="openChangeSalesManagerEdit()">
        <mat-icon>edit</mat-icon>
    </button>
</ng-container>